export function normalizeCourseKeyword(keyword = "") {
  return keyword.trim();
}

export function hasCourseSearchKeyword(keyword = "") {
  return Boolean(normalizeCourseKeyword(keyword));
}

export function canSubmitCourseSearch({
  keyword = "",
  activeKeyword = "",
} = {}) {
  const nextKeyword = normalizeCourseKeyword(keyword);
  const currentKeyword = normalizeCourseKeyword(activeKeyword);

  if (!nextKeyword && !currentKeyword) return false;
  return nextKeyword !== currentKeyword;
}

export function createDelayedLoadingController({
  setLoading,
  showDelay = 180,
  minVisible = 260,
  now = () => Date.now(),
  setTimeoutFn = setTimeout,
  clearTimeoutFn = clearTimeout,
} = {}) {
  let showTimer = null;
  let hideTimer = null;
  let visibleAt = 0;
  let pending = false;

  const clearTimer = (timer) => {
    if (!timer) return;
    clearTimeoutFn(timer);
  };

  const hide = () => {
    hideTimer = null;
    visibleAt = 0;
    setLoading(false);
  };

  return {
    start() {
      pending = true;
      clearTimer(showTimer);
      clearTimer(hideTimer);
      hideTimer = null;
      showTimer = setTimeoutFn(() => {
        showTimer = null;
        if (!pending) return;
        visibleAt = now();
        setLoading(true);
      }, showDelay);
    },
    stop() {
      pending = false;
      if (showTimer) {
        clearTimer(showTimer);
        showTimer = null;
        setLoading(false);
        return;
      }
      const elapsed = visibleAt ? now() - visibleAt : minVisible;
      const remaining = Math.max(0, minVisible - elapsed);
      if (remaining) {
        clearTimer(hideTimer);
        hideTimer = setTimeoutFn(hide, remaining);
        return;
      }
      hide();
    },
    cancel() {
      pending = false;
      clearTimer(showTimer);
      clearTimer(hideTimer);
      showTimer = null;
      hideTimer = null;
      hide();
    },
  };
}

export function buildCourseListParams({
  page_no,
  page_size,
  keyword = "",
  fee_type = "",
}) {
  const params = {
    page_no,
    page_size,
  };
  const courseName = normalizeCourseKeyword(keyword);

  if (fee_type) {
    params.fee_type = fee_type;
  }
  if (courseName) {
    params.course_name = courseName;
  }

  return params;
}
